// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fsOud","type":"styles_type__1ZGh9","choices":"styles_choices__3CDZj"};